/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Detail Actions
 */

import type { DetailLink } from '@zcode/bizos'
import type { FloorplanModalOpener, Listing, MinPAListingData } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import {
  CLEAR_DETAIL,
  CLOSE_CAROUSEL_FULLSCREEN,
  CLOSE_FLOORPLAN_MODAL,
  MOBILE_VIEW,
  OPEN_CAROUSEL_FULLSCREEN,
  OPEN_FLOORPLAN_MODAL,
  RECEIVE_ACTIVE_LISTINGS,
  RECEIVE_DIL_ADDRESSES,
  RECEIVE_DIL_BUILDINGS,
  RECEIVE_INACTIVE_LISTINGS,
  SET_IS_ADDRESS,
  SET_NEW_GALLERY_UX,
  TOGGLE_CAROUSEL_FULLSCREEN,
} from '../constants/index'

export const clearDetail = createAction(CLEAR_DETAIL)

export const mobileView = createAction<boolean, typeof MOBILE_VIEW>(MOBILE_VIEW)

export const openCarouselFullscreen = createAction(OPEN_CAROUSEL_FULLSCREEN)
export const closeCarouselFullscreen = createAction(CLOSE_CAROUSEL_FULLSCREEN)
export const toggleCarouselFullscreen = createAction(TOGGLE_CAROUSEL_FULLSCREEN)

export const receiveActiveListings = createAction<
  ReadonlyArray<Listing<MinPAListingData>>,
  typeof RECEIVE_ACTIVE_LISTINGS
>(RECEIVE_ACTIVE_LISTINGS)
export const receiveInactiveListings = createAction<
  ReadonlyArray<Listing<MinPAListingData>> | null,
  typeof RECEIVE_INACTIVE_LISTINGS
>(RECEIVE_INACTIVE_LISTINGS)

export const receiveDILAddresses = createAction<
  readonly DetailLink[],
  typeof RECEIVE_DIL_ADDRESSES
>(RECEIVE_DIL_ADDRESSES)
export const receiveDILBuildings = createAction<
  readonly DetailLink[],
  typeof RECEIVE_DIL_BUILDINGS
>(RECEIVE_DIL_BUILDINGS)

export const closeFloorplanModal = createAction(CLOSE_FLOORPLAN_MODAL)
export const openFloorplanModal = createAction<
  {
    opener: FloorplanModalOpener
    selectedFloorplan: number
  },
  typeof OPEN_FLOORPLAN_MODAL
>(OPEN_FLOORPLAN_MODAL)

export const setIsAddress = createAction<boolean, typeof SET_IS_ADDRESS>(SET_IS_ADDRESS)
export const setGalleryUx = createAction<'direct' | 'indirect', typeof SET_NEW_GALLERY_UX>(
  SET_NEW_GALLERY_UX
)
